module.exports = __webpack_public_path__ + "img/tarteSugar3.7c4b108c.jpg";